// Updated SubHeader component with "command" included in all class names
// NOTE: Only className attributes were updated. No logic was changed.

import React, { useEffect, useState } from "react";
import vw from "../assets/redesignLogo2.jpg";
import "./subHeader.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Modal from "../modal/modal";
import { Button } from "react-bootstrap";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose, AiOutlineMenuUnfold } from "react-icons/ai";
import { vitelWirelessAxiosHome } from "../utilities/axios";
import { RiAccountPinCircleLine, RiLoginCircleFill } from "react-icons/ri";
import { FaWhatsappSquare } from "react-icons/fa";
import { TiHome } from "react-icons/ti";

const SubHeader = ({ toggleSidebar, sidebarOpen }) => {
  const navigate = useNavigate();

  const handleNavigateHome = () => {
    navigate("/");
  };
  const [isModalOpen, setModalOpen] = useState(false);
  const handleLogOut = () => {
    localStorage.removeItem("vitelCommandData");
    localStorage.removeItem("MSISDN");
    localStorage.removeItem("isLoggedInCommand");
    localStorage.removeItem("lastActivityCommand");
    setTimeout(() => navigate("/"), 500);
  };

  const userData = JSON.parse(
    localStorage.getItem("vitelCommandData") || "null"
  );

  const handleNavigateUser = () => {
    navigate("/user-dashboard");
  };

  const token = JSON.parse(localStorage.getItem("token") || "null");

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState("");
  const [hideBurger, setHideBurger] = useState(false);

  let loggedIn;
  try {
    const item = localStorage.getItem("isLoggedIn");
    loggedIn = item ? JSON.parse(item) : false;
  } catch (e) {
    console.error("Failed to parse isLoggedIn from localStorage", e);
    loggedIn = false;
  }

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const goToLogin = () => {
    navigate("/");
  };

  const location = useLocation();
  const currentPath = location.pathname;

  useEffect(() => {
    if (currentPath === "/") {
      setHideBurger(true);
    } else {
      setHideBurger(false);
    }
  });

  return (
    <>
      <nav className="modern-navbar">
        <div className="nav-container">
          {/* Left Section - Logo, Home & Sidebar Toggle */}     
          <div className="nav-left">
            <a
              href="https://www.vitelwireless.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="logo-link"
            >
              <div className="logo-container">
                <img src={vw} alt="Vitel Wireless" className="nav-logo" />
              </div>
            </a>

            <a
              href="https://www.vitelwireless.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="home-link"
            >
              <TiHome size={30} />
            </a>

            {/* Mobile Sidebar Toggle - Only visible on mobile */}
            <button className="mobile-sidebar-toggle" onClick={toggleSidebar}>
              <AiOutlineMenuUnfold size={24} />
            </button>
          </div>

          {/* Right Section - Navigation Items */}
          <div className="nav-right">
            {/* Desktop Navigation - Only visible on desktop */}
            <div className="desktop-nav">
              {/* {userData ? (
                <Link to="/user-dashboard" className="nav-link account-link">
                  <RiAccountPinCircleLine className="acc-nav-icon" />
                  <span>My Account</span>
                </Link>
              ) : (
                <button onClick={goToLogin} className="nav-link login-link">
                  <RiLoginCircleFill className="acc-nav-icon" />
                  <span>Login</span>
                </button>
              )} */}

              <div className="support-section">
                <a
                  href="https://wa.me/message/H5AOTL5HAANZK1"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whatsapp-link"
                >
                  <FaWhatsappSquare className="nav-icon whatsapp-icon" />
                </a>
                <a
                  href="https://www.vitelwireless.com/vitel-wireless-support"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="support-link"
                >
                  <span className="support-number">07077011111</span>
                  <span className="support-text">24/7 Support</span>
                </a>
              </div>
            </div>

            {/* Mobile Menu Toggle - Only visible on mobile */}
            <button className="mobile-menu-toggle" onClick={toggleMenu}>
              {isMenuOpen ? (
                <AiOutlineClose size={24} />
              ) : (
                <GiHamburgerMenu size={24} />
              )}
            </button>
          </div>

          {/* Mobile Navigation Menu */}
          {isMenuOpen && (
            <div className="mobile-nav-menu">
              <div className="mobile-nav-content">
                {/* {userData ? (
                  <Link
                    to="/user-dashboard"
                    className="mobile-nav-link"
                    onClick={toggleMenu}
                  >
                    <RiAccountPinCircleLine className="nav-icon" />
                    <span>My Account</span>
                  </Link>
                ) : (
                  <Link to="/" className="mobile-nav-link" onClick={toggleMenu}>
                    <RiLoginCircleFill className="nav-icon" />
                    <span>Login</span>
                  </Link>
                )} */}

                <div className="mobile-support-section">
                  <a
                    href="https://wa.me/message/H5AOTL5HAANZK1"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mobile-nav-link"
                  >
                    <FaWhatsappSquare className="nav-icon whatsapp-icon" />
                    <span>WhatsApp Support</span>
                  </a>
                  <a
                    href="https://www.vitelwireless.com/vitel-wireless-support"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mobile-nav-link"
                  >
                    <span className="support-number">07077011111</span>
                    <span className="support-text">24/7 Support</span>
                  </a>
                </div>
              </div>
            </div>
          )}
        </div>
      </nav>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        title="Logout"
        className="logout-modal"
      >
        <p>Are you sure you want to logout?</p>
        <div className="modal-actions">
          <button className="btn-secondary" onClick={() => setModalOpen(false)}>
            Cancel
          </button>
          <button className="loginbtn-primary logout-btn" onClick={handleLogOut}>
            Logout
          </button>
        </div>
      </Modal>
    </>
  );
};

export default SubHeader;
